import { createIcon } from '../OriginIcon/iconHelper';
import React from 'react';

export default createIcon(
  'FlatRoof',
  <React.Fragment>
    <path d="M2,6 L22,6 L22,4 L2,4 L2,6 Z M4,7 L4,21 L13,21 L13,14 L18,14 L18,21 L20,21 L20,7 L4,7 Z" />
  </React.Fragment>
);
